import * as io from "io-ts";
import createGlobalState from "@ui/lib/createGlobalState";
import t from "../../../../../i18n";
import { notNull } from "diagnostics-lib/typescript";
import React from "react";
import type { PerformanceReporting } from "../../../../../api/useReporting";

export type ProjectAggregation = "TYPE" | "SITE" | "PROJECT";
export type ProjectAggregationOptions = { label: string; value: ProjectAggregation }[];

export const useProjectAggegation = createGlobalState({
  storage: "session",
  key: "reportingProjectAggegation",
  type: io.union([io.literal("TYPE"), io.literal("SITE"), io.literal("PROJECT")]),
  defaultValue: "SITE",
  scoped: false,
});

export const REST_PROJECT_AGGREGATION_TARGET_ID = "rest";

export function useProjectAggregationTargets(reporting: PerformanceReporting) {
  const [selectedProjectAggregation] = useProjectAggegation({});
  return React.useMemo(
    () => [
      ...Object.values(reporting.projectById)
        .map(({ id, name, typeId, siteId }) => {
          if (selectedProjectAggregation === "PROJECT" && id) return { id, name };
          /**
           * From 3.1 version, application categories are unique by their name (id === human readable name).
           */
          if (selectedProjectAggregation === "TYPE" && typeId) return { id: typeId, name: typeId };
          if (selectedProjectAggregation === "SITE" && siteId) return { id: siteId, name: siteId };
          return null;
        })
        .filter(notNull)
        .filter((entry, i, arr) => arr.findIndex(({ id }) => id === entry.id) === i),
      { id: REST_PROJECT_AGGREGATION_TARGET_ID, name: t("reporting.chart.aggregation.other") },
    ],
    [reporting, selectedProjectAggregation],
  );
}
